<!-- File row container - clickable -->
<div class="flex w-full text-[14px] leading-[24px] cursor-pointer bg-white hover:bg-gray-50"
  (click)="openFile(file())">
  
  <!-- Links: Spacing (wie ColorBar bei issue-row, aber leer/transparent) -->
  <div class="w-[5px]"></div>
  
  <!-- Mitte: Content Area (2 Rows) -->
  <div class="flex-1 flex flex-col px-2 py-1">
    
    <!-- Row 1: Icon + Filename -->
    <div class="leading-[22px]">
      <div class="float-left w-[18px] h-[18px] mr-1">
        <i class="block text-[24px] mt-[-2px] ml-[-3px]" [ngClass]="'icon-file-attachment'"></i>
      </div>
      <span>{{file()?.fileName}}</span>
    </div>
    
    <!-- Row 2: Metadaten (Datum, Größe) -->
    <div class="leading-[20px] text-[#848488]">
      {{getSizeinMb(file()?.size)}} MB · Erstellt von {{file()?.createdBy?.firstName}} {{file()?.createdBy?.lastName}} <app-relative-time [timestamp]="file()?.uploadedDateTime?.toString()" />
      <app-activity-owner-badge 
        class="ml-1"
        [owner]="file()?.getFirstFileOwner()" 
        [ownerId]="ownerId()">
      </app-activity-owner-badge>
    </div>

  </div>
  
  <!-- Rechts: Menu Area (geht über beide Rows) -->
  <div class="flex items-center mr-2">
    @if (shouldShowButton()) {
      <p-menu
        #menu
        (onShow)="onMenuShow()"
        (onHide)="onMenuHide()"
        [model]="menuItems()"
        [popup]="true"
        [appendTo]="'body'">
      </p-menu>
      <nx-default-button
        [ngClass]="{'nx-focus': menuVisible()}"
        (click)="menu.toggle($event); $event.stopPropagation()"
        [icon]="'icon-options'">
      </nx-default-button>
    }
  </div>
</div>

<!-- PDF Viewer Dialog -->
<p-dialog
  [header]="currentHeader()"
  [(visible)]="pdfDialogVisible"
  [style]="{ width: '800px', height: '80%' }"
  [dismissableMask]="true"
  [modal]="true"
  appendTo="body"
  styleClass="rounded-md p-[10px] bg-white"
  contentStyleClass="noScrollbar pt-[10px]">
  <div style="width: 100%; height: 100%">
    <ng2-pdfjs-viewer 
      #pdfViewerAutoLoad 
      locale="de-DE"
      [viewerId]="'unique-id'"
      [externalWindow]="false">
    </ng2-pdfjs-viewer>
  </div>
</p-dialog>

<!-- Image Viewer Dialog -->
<p-dialog
  [header]="currentHeader()"
  [(visible)]="imageDialogVisible"
  [style]="{ width: '800px', height: '80%' }"
  [dismissableMask]="true"
  [modal]="true"
  appendTo="body"
  styleClass="rounded-md p-[10px] bg-white"
  contentStyleClass="noScrollbar pt-[10px]">
  <div style="width: 100%; height: 100%" class="flex justify-center items-center">
    <img [src]="currentImage()">
  </div>
</p-dialog>
